import { useEffect, useRef } from 'react'
import { Link } from 'react-router-dom'
import BuildNotificationBar from './BuildNotificationBar'

interface BuildNavProps {
	className?: string;
	onHeightChange?: (height: number) => void;
}

const BuildNav = ({ className = '', onHeightChange }: BuildNavProps) => {
	const navRef = useRef<HTMLElement>(null)

	useEffect(() => {
		if (!navRef.current || !onHeightChange) return

		const observer = new ResizeObserver((entries) => {
			for (const entry of entries) {
				onHeightChange(entry.contentRect.height)
			}
		})

		observer.observe(navRef.current)
		return () => observer.disconnect()
	}, [onHeightChange])

	const Logo = ({ fill = "#FF5C00" }: { fill?: string }) => (
		<Link to="/" aria-label="Go to build instructions home">
			<svg className="h-7 w-auto" viewBox="0 0 98 33" fill="none" xmlns="http://www.w3.org/2000/svg">
				<path d="M27.6441 17.0236L30.5811 14.0866C32.076 12.5939 33 10.5303 33 8.2511C33 3.6949 29.3061 0.00109999 24.75 0.00109999C22.4708 0.00109999 20.4072 0.9251 18.9145 2.42L16.5011 4.8334V0H0V16.5H4.8323L2.4134 18.9189C0.9229 20.4116 0 22.473 0 24.75C0 29.3061 3.6938 33 8.25 33C10.5292 33 12.5928 32.076 14.0855 30.5811L17.0225 27.6441C18.1951 30.7724 21.2113 33 24.7489 33C29.3051 33 32.9989 29.3061 32.9989 24.75C32.9989 21.2124 30.7713 18.1951 27.643 17.0236H27.6441Z"
					fill={fill}
					style={{ fill: fill, fillOpacity: 1 }} />
				<path d="M91.1424 25.6678C88.2139 25.6678 86.0645 23.5721 86.0645 20.4555V11.8579H89.1273V19.8644C89.1273 21.7451 90.1752 22.8736 91.8141 22.8736C93.5605 22.8736 94.6889 21.5839 94.6889 19.6495V11.8579H97.7518V25.3454H95.065L94.9307 23.8945H94.7695C93.9366 25.023 92.7813 25.6678 91.1424 25.6678Z"
					fill={fill}
					style={{ fill: fill, fillOpacity: 1 }} />
				<path d="M76.8406 25.667C74.9868 25.667 73.4285 24.9416 72.6224 23.7325H72.4612L72.3 25.3446H69.6133V6H72.6762V13.2811H72.8374C73.6703 12.1795 75.1211 11.5347 76.8675 11.5347C80.414 11.5347 83.047 14.5438 83.047 18.6008C83.047 22.6578 80.414 25.667 76.8406 25.667ZM76.2227 22.8996C78.3721 22.8996 79.8498 21.1532 79.8498 18.6008C79.8498 16.0484 78.3721 14.302 76.2227 14.302C74.0733 14.302 72.6762 16.0216 72.6762 18.6008C72.6762 21.207 74.0733 22.8996 76.2227 22.8996Z"
					fill={fill}
					style={{ fill: fill, fillOpacity: 1 }} />
				<path d="M62.9245 25.3445V11.8571H65.9874V25.3445H62.9245ZM64.4559 9.92262C63.3812 9.92262 62.5215 9.08973 62.5215 7.98817C62.5215 6.8866 63.3812 6.05371 64.4559 6.05371C65.5306 6.05371 66.3904 6.8866 66.3904 7.98817C66.3904 9.08973 65.5306 9.92262 64.4559 9.92262Z"
					fill={fill}
					style={{ fill: fill, fillOpacity: 1 }} />
				<path d="M46.248 25.3448V6.5376H49.4184V14.2486H50.7886L56.3233 6.5376H60.0848L53.5829 15.5919V15.7531L60.4878 25.3448H56.7263L50.7886 17.1234H49.4184V25.3448H46.248Z"
					fill={fill}
					style={{ fill: fill, fillOpacity: 1 }} />
			</svg>
		</Link>
	)

	return (
		<nav
			ref={navRef}
			className={`bg-primary h-[84px] md:h-[104px] w-full ${className}`}
		>
			<BuildNotificationBar />

			<div className="bg-primary md:pl-5 md:pr-5 pl-5 pr-5 w-full h-[56px] md:h-[70px]">
				<div className="mx-auto flex justify-between items-center h-full w-full">
					<Logo fill="white" />
				</div>
			</div>
		</nav>
	)
}

export default BuildNav
